import axios from '@/plugins/axiosV2'

const http = axios(process.env.VUE_APP_API_TICKETS+'/miarea');

export default {
  obtener_dependencias() {
    return http.get(`/dependencias`);
  }
};